import React from 'react';
import { useTranslation } from 'react-i18next';
import {Link, } from 'react-router-dom';


function Footer () {

	const { t } = useTranslation()

// ----------- Get the municipalite Name from URL Query Params START-------------
const search = window.location.search;
const params = new URLSearchParams(search);
const tenant = params.get('tenant');
// ----------- Get the municipalite Name from URL Query Params END-------------

		return (
			
			<footer className='main-footer'>
				<div className='footer-bottom'>
					<div className='auto-container'>
						<div className='row clearfix'>


							<div className='copyright-column col-lg-6 col-md-6 col-sm-12'>
								<div className='copyright'>{new Date().getFullYear()} © {t('ARRB')} 
								<Link to={'/msis?tenant='+tenant}> MSIS</Link></div>
							</div>


							<div className='social-column col-lg-6 col-md-6 col-sm-12'>
								<ul>
									<li className='follow'>{t('app_name')} </li>

								</ul>
							</div>

						</div>
					</div>
				</div>
			</footer>
		)
	}


export default Footer  